<script>
    import { getContext, onMount } from 'svelte';
    import { scaleLinear } from "d3-scale";
    import { line, curveBasis } from 'd3-shape';
    import { max } from 'd3-array';
    import { axisBottom, axisLeft } from 'd3-axis';
    import { select } from "d3-selection";
    import Number from './util/Number.svelte';


    export let dataKey;
    const n_bins = (24*3600/300);
    const {traces, isActive, threshold, hoverIdx} = getContext(dataKey);
    const range = (min, max) => [...Array(max - min + 1).keys()].map(i => i + min);

    $: keys = $traces[0] ? Object.keys($traces[0]) : [];
    $: num_active_locations = $isActive.reduce((res, v) => res += v, 0); 
    $: values = !$hoverIdx ? [] : $isActive.reduce((agg, v, i) => {
        if (v) {
            const trace = $traces[i];
            const value = keys.map(k => +trace[k]);
            value.forEach((v, i) => {
                const day = Math.floor(keys[i] / n_bins);
                const bin = keys[i] % n_bins;
                // console.log(day < 13, bin < 287);
                // console.log(agg);
                // console.log(agg[day]);
                // console.log(agg[day][bin]);
                agg[day][bin].value += v / num_active_locations;
            });
        }
        return agg;
    }, keys.reduce((agg, k, i) => {
        const day = Math.floor(k / n_bins);
        agg[day] = [...agg[day] || [], {
            bin: k % n_bins,
            value: 0
        }];
        return agg;
    }, {}));

    // --- Scales
    const timeScale = scaleLinear()
        .domain([0, 24*3600/300])
        .range([28, 395]);
    const activityScale = scaleLinear()
        .domain([0, 15])
        .range([70, 5]);
    const activityPath = line()
        .curve(curveBasis)
        .x(t => timeScale(t.bin))
        .y(t => activityScale(t.value));

    // --- Axes
    let activityAxesG = [];
    let timeAxesG = [];
    
    const activityAxis = axisLeft(activityScale)
        .ticks(5);
    const tickValuesT = [0, 6*3600/300, 12*3600/300, 18*3600/300];  
    const tickLabelsT = ['00:00', '06:00', '12:00', '18:00'];
    const timeAxis = axisBottom(timeScale)
        .tickValues(tickValuesT)
        .tickFormat((d, i) => tickLabelsT[i]);

    onMount(() => {
        timeAxesG.forEach(g => {
            select(g)
              .call(timeAxis)
              .call(g => g.select('.domain').remove());
        });

        activityAxesG.forEach(g => {
            select(g)
              .call(activityAxis)
              .call(g => g.select('.domain').remove());
        });
    });
    
    $: updateActivityAxis(values);
    function updateActivityAxis(values) {
        if (!$hoverIdx) {
            activityScale.domain([0, 15]);
        } else {
            const upper = Object.keys(values).reduce((m, k) => {
                const v = max(values[k], v=> v.value);
                if (v > m) {
                    m = v;
                }
                return m;
            }, 0);
            activityScale.domain([0, upper+2]);
        }
        
        activityAxesG.forEach(g => {
            if (g) {
                select(g)
                  .call(activityAxis)
                  .call(g => g.select('.domain').remove());
            }
        });
    }

</script>

<div class='col card'>
    <span>Brush limit <Number bind:value={$threshold} min=0 max=2 step=0.05 decimals=2/></span>
    <div class='row'>
        <div class='col'>
        {#each range(0, 6) as day}
            <svg width=400 height=100>
                {#if day in values}
                <g>
                    <path d={activityPath(values[day])}
                        fill='transparent'
                        stroke='currentColor' />
                </g>
                {/if}
                <g bind:this={activityAxesG[day]} transform='translate(28, 0)'>
                    <g transform='translate(-20, 25) rotate(-90)'>
                        <text fill='currentColor' dx='-0.71em'>num cars</text>
                    </g>
                </g>
                <g bind:this={timeAxesG[day]} transform='translate(0, 70)'>
                    <g transform='translate(200, 18)'>
                        <text fill='currentColor' dy='0.71em'>time of day</text>
                    </g>
                </g>
            </svg>
        {/each}
        </div>
        <div class='col'>
            {#each range(7, 13) as day}
                <svg width=400 height=100>
                    {#if day in values}
                    <g>
                        <path d={activityPath(values[day])}
                            fill='transparent'
                            stroke='currentColor' />
                    </g>
                    {/if}
                    <g bind:this={activityAxesG[day]} transform='translate(28, 0)'>
                        <g transform='translate(-20, 25) rotate(-90)'>
                            <text fill='currentColor' dx='-0.71em'>num cars</text>
                        </g>
                    </g>
                    <g bind:this={timeAxesG[day]} transform='translate(0, 70)'>
                        <g transform='translate(200, 18)'>
                            <text fill='currentColor' dy='0.71em'>time of day</text>
                        </g>
                    </g>
                </svg>
            {/each}
            </div>
    </div>
    
</div>

<style>
div {
    width: 800px;
}

</style>